import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnInit
} from '@angular/core';

@Component({
  selector: 'app-popup-notifier',
  templateUrl: './popup-notifier.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupNotifierComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() validationMsg = false;
  @Input() cancelTitle: string;
  @Input() validationTitle: string;
  @Output() hidePopupNotify = new EventEmitter<boolean>(false);
  @Output() agreePopupNotify = new EventEmitter<boolean>();
  @Input() showCancel: boolean;
  ngOnInit() {}

  cancelEvent() {
    this.hidePopupNotify.emit(true);
  }
  agreeEvent() {
    this.agreePopupNotify.emit(true);
  }
}
